import React from 'react';

export default function LimitMarketLayout({ children }) {
  return (
    <div className="limit-market-app limit-market-no-sidebar">
      <main className="main-content">{children}</main>
    </div>
  );
}
